module.exports = __webpack_public_path__ + "img/installAndroid.7c746ece.png";